export class LogicalGroupParent {
  groupId = '00000000-0000-0000-0000-000000000000';
  orderNumInGroup = 0;
}
